import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TimelinePage } from '../screens/admin/TimelinePage';

const searchSchema = z.object({
  /** Any identifier: document, batch, unit or trace id. With it the page is that file's story. */
  q: z.string().optional(),
  /** The finder's search: part of a company, job or file name, and a period (yyyy-MM-dd). */
  find: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  /** Only one company's arrivals (its slug), as its page links here. */
  company: z.string().optional(),
});

export const Route = createFileRoute('/admin/timeline')({
  validateSearch: searchSchema,
  component: TimelinePage,
});
